import { jsxs as x, jsx as i } from "react/jsx-runtime";
import { forwardRef as j, useState as w, useEffect as E } from "react";
import { c as s } from "./tw-cn-mXgPecoF.mjs";
import { ERROR_IMAGE_URL as K } from "./utils.es.js";
import { e as d } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as N } from "./variance-DhhqoHkK.mjs";
const T = N(
  [
    "relative overflow-hidden",
    "after:content-[''] after:absolute after:inset-0 after:border after:border-opacity-black-5 after:rounded-[inherit] after:pointer-events-none"
  ],
  {
    variants: {
      ratio: {
        "3_4": "aspect-[3/4]",
        "2_3": "aspect-[2/3]",
        "1_1": "aspect-[1/1]",
        "2_1": "aspect-[2/1]",
        "3_2": "aspect-[3/2]",
        "4_3": "aspect-[4/3]",
        "6_5": "aspect-[6/5]",
        "16_9": "aspect-[16/9]"
      },
      shape: {
        roundedRectangle_8: "rounded-8",
        roundedRectangle_12: "rounded-12",
        roundedRectangle_16: "rounded-16",
        roundedRectangle_20: "rounded-20",
        capsule: "rounded-capsule",
        rectangle: "",
        asymmetric_12_12_0_0: "rounded-t-12"
      },
      pcRatio: {
        "3_4": "pc:aspect-[3/4]",
        "2_3": "pc:aspect-[2/3]",
        "1_1": "pc:aspect-[1/1]",
        "2_1": "pc:aspect-[2/1]",
        "3_2": "pc:aspect-[3/2]",
        "6_5": "pc:aspect-[6/5]"
      },
      pcShape: {
        roundedRectangle_8: "pc:rounded-8",
        roundedRectangle_12: "pc:rounded-12",
        roundedRectangle_16: "pc:rounded-16",
        roundedRectangle_20: "pc:rounded-20",
        capsule: "pc:rounded-capsule",
        rectangle: "",
        asymmetric_12_12_0_0: "pc:rounded-t-12"
      }
    }
  }
);
function u(e, t) {
  return e ? { type: "primary" } : t ? { type: "fallback", fallbackImage: t } : { type: "failed" };
}
function C(e, t) {
  switch (e.type) {
    case "primary":
      return t;
    case "fallback":
      return e.fallbackImage;
    case "failed":
      return K;
  }
}
const P = ({ alt: e, className: t, src: a, loading: r, onError: c }) => /* @__PURE__ */ i("img", { alt: e, className: t, loading: r, onError: c, src: a }), D = j(
  ({
    shape: e,
    ratio: t,
    image: a,
    fallbackImage: r,
    alt: c,
    className: l,
    imgClassName: _,
    imageComponent: f,
    loading: m,
    children: y,
    width: n,
    ...R
  }, h) => {
    const [o, p] = w(() => u(a, r)), b = f ?? P;
    E(() => {
      p(u(a, r));
    }, [a, r]);
    const v = C(o, a), g = T({
      ...d({
        property: e,
        mobileKey: "shape",
        pcKey: "pcShape"
      }),
      ...d({
        property: t,
        mobileKey: "ratio",
        pcKey: "pcRatio"
      })
    });
    return /* @__PURE__ */ x(
      "div",
      {
        className: s(g, l),
        ref: h,
        style: { width: n ? `${n / 10}rem` : void 0 },
        ...R,
        children: [
          /* @__PURE__ */ i(
            b,
            {
              alt: c ?? "Thumbnail",
              className: s("mx-auto size-full bg-fill-neutral-weak1 object-center", _, {
                "object-cover": o.type !== "failed"
              }),
              loading: m,
              onError: () => {
                p((S) => S.type === "primary" && r && r !== a ? { type: "fallback", fallbackImage: r } : { type: "failed" });
              },
              src: v
            }
          ),
          y
        ]
      }
    );
  }
);
D.displayName = "NDS.Thumbnail";
export {
  D as T
};
